enum CustodianName {
  NEOKRED = 'neokred',
  INDIAN_BANK = 'indian_bank',
  SHIVALIK_BANK = 'shivalik_neokred',
}

type MaintenanceConfig = {
  /**
   * start_time is in 'YYYY-MM-DD HH:MM:SS' Format
   * Example: 2025-09-24 18:45:00
   */
  start_time: string | null;
  /**
   * end_time is in 'YYYY-MM-DD HH:MM:SS' Format
   * Example: 2025-09-24 19:45:00
   */
  end_time: string | null;
  isUnderMaintenance: boolean;
};

interface BaseCustodian {
  asset_symbol: 'INR';
  base_deposit_fee: number;
  custodian_network: string;
  delta_wallet_address: null | string;
  is_subaccount_allowed: boolean;
  max_deposit_amount: number;
  min_deposit_amount: number;
  network: string;
  payment_tag: null | string;
  sort_priority: null | number;
  variable_deposit_fee: number;
}

interface NeokredCustodian extends BaseCustodian {
  fiat_deposit_custodian: CustodianName.NEOKRED;
  maintenance_config: {
    UPI: MaintenanceConfig;
    IMPS: MaintenanceConfig;
  };
}

interface IndianBankCustodian extends BaseCustodian {
  fiat_deposit_custodian: CustodianName.INDIAN_BANK;
  maintenance_config: {
    NEFT: MaintenanceConfig;
  };
}

interface ShivalikBankCustodian extends BaseCustodian {
  fiat_deposit_custodian: CustodianName.SHIVALIK_BANK;
  maintenance_config: {
    IMPS: MaintenanceConfig;
  };
}

type Custodian = NeokredCustodian | IndianBankCustodian | ShivalikBankCustodian;

interface MaintenanceState {
  neokredUpi: MaintenanceConfig | null;
  neokredImps: MaintenanceConfig | null;
  indianBankNeft: MaintenanceConfig | null;
  shivalikBankImps: MaintenanceConfig | null;
}

export type { Custodian, MaintenanceState, MaintenanceConfig };
export { CustodianName };
